.logo {
	font-size: 6rem;
	text-align: center;
	font-weight: bold;
}
